module.exports = __webpack_public_path__ + "prod/1.42.2/img/mixOsBanner.7373c2ca.png";